import { Flow_0_0_2, getFullItemOne } from '@flexus/core';
import { skipWhile, take, map } from 'rxjs/operators';
import { SIL_97 } from './SIL_97';

export const SIL_106: Flow_0_0_2 = {
	id: '106',
	name: 'assessor_on_site',
	itemType: 'flow',
	fetchLevel1And2: SIL_97.fetchLevel1And2,
	header: {
		title: (store, bf) => {
			return store.select(getFullItemOne).pipe(
				skipWhile(res => !res),
				take(1),
				map(itemOne => {
					if (itemOne) {
						let title = 'Assessor on Site';
						if (itemOne?.loan_information?.mavenclaimnumber) {
							title += ` : ${itemOne?.loan_information?.mavenclaimnumber}`;
						}
						if (itemOne.applicant?.surname) {
							title += ` - ${itemOne.applicant?.surname}`;
						}

						return title;
					} else {
						return 'Assessor on Site';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		...SIL_97.footer
	},
	instructions: {
		...SIL_97.instructions
	},
	actionPanel: SIL_97.actionPanel,
	serverCalls: {
		...SIL_97.serverCalls
	},
	startNode: 'AssessorOverview',
	nodes: {
		...SIL_97.nodes
	},
	bigFormToStoreMapper: {
		...SIL_97.bigFormToStoreMapper
	}
};
